type ScrollLockDocument = Pick<Document, 'body' | 'documentElement'>;

export const lockDocumentScroll = (targetDocument: ScrollLockDocument): (() => void) => {
    const previousBodyOverflow = targetDocument.body.style.overflow;
    const previousDocumentOverflow = targetDocument.documentElement.style.overflow;

    targetDocument.body.style.overflow = 'hidden';
    targetDocument.documentElement.style.overflow = 'hidden';

    return () => {
        targetDocument.body.style.overflow = previousBodyOverflow;
        targetDocument.documentElement.style.overflow = previousDocumentOverflow;
    };
};
